import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { SEO } from "../../components/SEO";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, { credentials: "include" })
      .then((r) => {
        if (r.ok) navigate("/admin", { replace: true });
        else setChecking(false);
      })
      .catch(() => setChecking(false));
  }, [navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center relative overflow-hidden px-4" data-testid="admin-login-page">
      <SEO title="Admin Login" description="Administrator access for Neeraj Battan & Associates." path="/admin/login" />
      <div className="grain-overlay" />
      <div className="relative w-full max-w-md rounded-2xl bg-white p-10 shadow-2xl">
        <div className="text-center">
          <span className="inline-flex w-14 h-14 rounded-full bg-navy items-center justify-center">
            <ShieldCheck size={26} className="text-gold" />
          </span>
          <h1 className="mt-6 font-serif text-3xl font-bold text-navy">Administration</h1>
          <p className="mt-2 text-xs font-mono uppercase tracking-[0.25em] text-slate-400">Neeraj Battan &amp; Associates</p>
          <p className="mt-5 text-sm text-slate-500 leading-relaxed">
            Restricted area. Sign in with the authorised Google account to manage articles and enquiries.
          </p>
          <button
            onClick={login}
            disabled={checking}
            data-testid="admin-login-button"
            className="mt-8 w-full inline-flex items-center justify-center gap-3 rounded-full bg-navy px-6 py-4 text-sm font-semibold text-white hover:bg-navy-light disabled:opacity-60 transition-colors"
          >
            <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M21.35 11.1h-9.17v2.73h6.51c-.33 3.81-3.5 5.44-6.5 5.44C8.36 19.27 5 16.25 5 12c0-4.1 3.2-7.27 7.2-7.27 3.09 0 4.9 1.97 4.9 1.97L19 4.72S16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12c0 5.05 4.13 10 10.22 10 5.35 0 9.25-3.67 9.25-9.09 0-1.15-.15-1.81-.15-1.81z"/></svg>
            {checking ? "Checking session…" : "Sign in with Google"}
          </button>
        </div>
      </div>
    </div>
  );
}
